/* Home-only JS: Fireblood product card link rewrite to getfireblood.com. Shuffle dropped 2026-04-21 — slideshow-component internal state incompatible with client-side reorder. */
document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('a[href*="/products/fireblood"]').forEach(function(a) {
    var href = a.getAttribute('href') || '';
    if (/\/products\/fireblood(\?|$|#)/.test(href)) {
      a.href = 'https://getfireblood.com/';
      a.target = '_blank';
      a.rel = 'noopener';
    }
  });
});
